(function ($) {
  function applyCardGridMatchHeight() {
    if (typeof $.fn.matchHeight === 'undefined') {
      return;
    }

    $('.card-grid-with-content .card .card-overlay h3')
      .matchHeight({ remove: true })
      .matchHeight();
  }

  $(document).ready(function () {
    if ($('.card-grid-with-content').length > 0) {
      applyCardGridMatchHeight();
    }
  });

  var resizeTimer;
  $(window).on('resize', function () {
    if ($('.card-grid-with-content').length === 0) {
      return;
    }
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyCardGridMatchHeight, 250);
  });

  $(window).on('load', function () {
    if ($('.card-grid-with-content').length > 0) {
      applyCardGridMatchHeight();
    }
  });
})(jQuery);
